import References from "../../helpers/Reference";

export const getTheme = () => {
    const theme = localStorage.getItem('tsm_theme');
    return theme ? theme : 'light';
}

export const saveTheme = ( theme ) => {
    localStorage.setItem('tsm_theme', theme);
}

export const getShortView = () => {
    return localStorage.getItem('tsm_short_view');
}

export const getProjectAreaView = () => {
    return localStorage.getItem('tsm_project_area');
}

export const saveAreaProject = ( type ) => {
    localStorage.setItem('tsm_project_area', type);
}

export const saveShortView  = ( isShort ) => {
    localStorage.setItem('tsm_short_view', isShort ? 'short' : 'full');
}

export const filterAKB = (akb, filter) => {
    return akb.filter((item) => 
        (!filter.hasOwnProperty('station_name') || item?.station_name?.toUpperCase().indexOf(filter.station_name.toUpperCase()) > -1) 
        && 
        (!filter.hasOwnProperty('district') || item?.district?.toUpperCase().indexOf(filter.district.toUpperCase()) === 0)                    
        &&
        (!filter.hasOwnProperty('maintained') || item?.maintained)
    );
}

export const getExtraChannels = ( item ) => {
    const result = [];
    const mchs = Object.keys(References.tsmExtraMCHS);
    mchs.forEach(element => {
        if (item.hasOwnProperty(element)) {
            result.push({[element]: item[element]})
        }
    });
    return result;
}

export const formatExtraChannelsChart = ( channels ) => {
    const result = [];
    channels.forEach(channel => {
        const types = Object.keys(channel)
        types.forEach(item => {
            const mchs = Object.keys(channel[item])
            mchs.forEach(mch => {
                result.push({
                    label: channel[item][mch]?.name,
                    uuid: mch,
                    key: JSON.stringify({path: item, uuid: mch})
                })
            })
        })
    })
    return result;    
}

export const getChartPath = (chartJSON) => {
    try {
        const json = JSON.parse(chartJSON)        
        return json.path
    } catch (e) {
        return null
    }
}

export const prepareStartExtraChannel = (extraChannels, channel) => {
//    console.log(extraChannels)
    //каналов нет вообще - сбрасываем в канал по умолчанию
    if (extraChannels.length === 0)
        return null;

    //экстра канал отсутствует в запрощенном - показываем канал по умолчанию (напряжение)
    const channels = extraChannels.filter(item => item.hasOwnProperty(channel));
    if (channels.length === 0)
        return null;

    const firstChannel = channels[0][channel]    
    //console.log(firstChannel)
    //тип канала найден - устанавливаем первый из списка
    const uuid = Object.keys(firstChannel)[0];
    //console.log(JSON.stringify({path: channel, uuid: uuid}))
    return JSON.stringify({path: channel, uuid: uuid})
}